module.exports = __webpack_public_path__ + "static/flags/TX-36b41794c085ab5cf39cbcf9ebf97d8d.gif";